if($('header#header').length){
    $('input[type="search"]').attr('placeholder', 'Co hledáte? Např. toaletní papír MAXI...');
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools')
    $('.top-navigation-tools .dropdown').clone().appendTo('.footer-bottom .right')
    $('.top-navigation-contacts .project-phone').find('span').before('<div class="photo"><img src="/user/documents/upload/sablona-nemazat/vojta.png" alt="Jiříček"><span class="name"><strong>Vojtěch Jiříček</strong> / CEO & Founder</span></div>').append('<span class="help">Rádi Vám poradíme!</span>')
    $('.top-navigation-contacts .project-phone').clone().appendTo('.responsive-tools')
    $('.header-top').append($('.user-action'))
    $('.header-top').append($('.top-navigation-bar .responsive-tools'));
    $('.responsive-tools').append('<a href="' + favorite_url + '" data-target="favorite" class="favorite"><i class="favorite_icon"><span class="number"></span></i></a>')
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
    })
    $('.search').append('<a href="#" class="toggle-window" data-target="navigation"></a>');
    $('input#loginWidgetEmail').attr('placeholder', 'E-mail');
    $('input#loginWidgetPassword').attr('placeholder', 'Heslo');
    $('a[href="/klient/zapomenute-heslo/"]').text('Zapomněli jste heslo?');
    $('h2#loginHeading').text('Zákaznické centrum') ;

    $('.dropdown-menu li a[href="/action/Currency/changeCurrency/?currencyCode='+getShoptetDataLayer('currency')+'"]').addClass('activeCurrency')
    
}

$(document).ready(function () {
        let target = 'cart';
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on('mouseenter', function () {
            var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
           
            shoptet.popups.showPopupWindow(target, show);
        });
});

// Pomocná: debounce
function debounce(fn, wait = 150) {
  let t;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function buildMenusFromMaster() {
  const $nav = $('.navigation-in').first();
  const $mainMenu = $nav.find('ul.menu-level-1').first();
  const $master = $('.menu-helper > ul').first();

  if (!$nav.length || !$mainMenu.length || !$master.length) {
    console.warn('❌ Navigace nebo master seznam nenalezen.');
    return;
  }

  // Pokud je kontejner neviditelný (šířka 0), nemá smysl měřit
  const maxWidth = $nav.innerWidth();
  if (!maxWidth) {
    // Vyčisti next, ale nic nestav – vrátíme se při dalším resize
    $nav.find('ul.menu-level-1.next').remove();
    return;
  }

  // Reset: smaž next menu a vyprázdni hlavní
  $nav.find('ul.menu-level-1.next').remove();
  $mainMenu.empty();

  let currentWidth = 0;
  let $nextMenu = null;

  // Projdi master položky v původním pořadí
  $master.children('li').each(function() {
    // Klon s eventy (pokud je potřebuješ zachovat)
    const $li = $(this).clone(true);

    // Nejdřív to zkusit dát do hlavního menu
    $mainMenu.append($li);

    // Změříme šířku právě přidané položky (s marginy)
    const itemWidth = $li.outerWidth(true);

    // Kdyby teď přeteklo, přesuneme do next řádku
    if (currentWidth + itemWidth <= maxWidth) {
      currentWidth += itemWidth;
    } else {
      // Vytvoř next řádek až v momentě, kdy ho poprvé potřebujeme
      if (!$nextMenu) {
        $nextMenu = $('<ul class="menu-level-1 next" role="menubar" data-testid="headerMenuItems"></ul>');
        $nav.append($nextMenu);
      }
      // Přesun z hlavního do next
      $li.detach();
      $nextMenu.append($li);
    }
  });

  // Po sestavení menu znovu navážeme observer na submenu
  observeSubmenuOpen();
}

function observeSubmenuOpen() {
  const $nav = $('.navigation-in').first();
  const $nextMenu = $nav.find('.menu-level-1.next');
  if (!$nextMenu.length) return;

  // Zrušit případné staré observéry? Nejjednodušší je navazovat je znovu po rebuild
  // a spoléhat, že staré elementy byly odstraněny.

  $('.menu-level-1:not(.next) > li.ext').each(function () {
    const el = this;
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasExp = $(el).hasClass('exp');
          const $submenu = $(el).find('.menu-level-2:visible');

          if (hasExp && $submenu.length) {
            const submenuHeight = $submenu.outerHeight(true);
            $nextMenu.css('margin-top', submenuHeight + 'px');
          } else {
            $nextMenu.css('margin-top', '');
          }
        }
      }
    });

    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
}

// Původní funkci nahradíme jedinou, která vždy rebuilduje z masteru
const splitMenuByCssWidth = () => {
  // Použij rAF, aby se měření dělo po reflow
  window.requestAnimationFrame(buildMenusFromMaster);
};

$(function() {
  splitMenuByCssWidth();
  // Debounced resize
  $(window).on('resize', debounce(splitMenuByCssWidth, 150));
});

/*

$(document).ready(function () {
    if ($(window).width() >= 768) {
        splitMenuByCssWidth();
        observeSubmenuOpen();
    }
});*/
/*
$(window).on('resize', function () {
    clearTimeout(window._menuResize);
    window._menuResize = setTimeout(function () {
        if ($(window).width() >= 768) {
            splitMenuByCssWidth();
            observeSubmenuOpen();
        }
    }, 350);
});*/


 shoptet.scripts.setCustomCallback('shoptet.menu.splitHelperMenu', function(args) {
    setTimeout(function(){
        splitMenuByCssWidth();
        observeSubmenuOpen();
    }, 300)
    
});